import { useAuth as useOidcAuth } from "react-oidc-context";
import {
  getTokenRoleSnapshot,
  resolveConnectorServiceForSnapshot,
} from "../utils/auth/connectorRouting";

export function useAuthRoles() {
  const { user } = useOidcAuth();
  const token = (user && (user.access_token || user.id_token)) || "";
  const {
    decoded,
    realmRoles: businessRoles,
    isAdmin,
  } = getTokenRoleSnapshot(token);

  // Roles administrativos
  const isProvider = businessRoles.includes("data_provider");
  const isConsumer = businessRoles.includes("data_consumer");

  const isOnlyConsumer = isConsumer && !isProvider;
  const canSeeProviderFeatures = isProvider;
  const canSeeConsumeFeatures = isConsumer;

  return {
    token,
    roles: businessRoles,
    isAdmin,
    isProvider,
    isConsumer,
    isOnlyConsumer,
    canSeeProviderFeatures,
    canSeeConsumeFeatures,
    preferredConnectorService: isAdmin
      ? "springConnector"
      : resolveConnectorServiceForSnapshot(
          {
            isAdmin,
            hasProviderRole: isProvider,
            isConsumerOnly: isOnlyConsumer,
          },
          "springConnector",
        ),
    decoded,
  };
}
